let all_footer_elms = $('.foot-title');

if (all_footer_elms.length) {
  all_footer_elms.off('click.slideToggle').on('click.slideToggle', function () {
    $(this).toggleClass('open');
    $(this).next().slideToggle(150);
  });
}

let product_tab_3 = $('.tab-title-3');

if (product_tab_3.length > 0) {
  product_tab_3.click(function(e) {
    e.preventDefault();
    $(this).closest('.wrapper-tab-content').find('#collapse-tab3').slideToggle(150);
    $(this).find('.tab-links').toggleClass('active');
  });
}
